export default __webpack_public_path__ + "static/media/svg-7.33051072.svg";